import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {
  BillingData,
  CaseData,
  ProgressData,
  SaleData,
} from '@core/interfaces/partners-ALI';

@Component({
  selector: 'allies-progress-modal-skeleton',
  templateUrl: './allies-progress-modal-skeleton.component.html',
  styleUrls: ['./allies-progress-modal-skeleton.component.scss'],
})
export class AlliesProgressModalSkeletonComponent implements OnInit {
  // ===== Inputs =====
  @Input() currentYear!: number;
  @Input() mockProgressData!: ProgressData;
  @Input() saleData: SaleData | null = null;

  // ===== Outputs =====
  @Output() scrollToBenefits = new EventEmitter<void>();

  // ===== Estado interno =====
  readonly alignmentClass = 'text-start-dynamic';
  readonly alignmentClassMobile = 'text-start-dynamic';
  readonly activeCaseData: CaseData | null = null;

  // ===== Datos de facturación =====
  readonly billingData: BillingData = [
    {
      trimestre: 1,
      total: 0,
      months: [
        { name: 'Ene', amount: '0.00' },
        { name: 'Feb', amount: '0.00' },
        { name: 'Mar', amount: '0.00' },
      ],
    },
    {
      trimestre: 2,
      total: 0,
      months: [
        { name: 'Abr', amount: '0.00' },
        { name: 'May', amount: '0.00' },
        { name: 'Jun', amount: '0.00' },
      ],
    },
    {
      trimestre: 3,
      total: 0,
      months: [
        { name: 'Jul', amount: '0.00' },
        { name: 'Ago', amount: '0.00' },
        { name: 'Sep', amount: '0.00' },
      ],
    },
    {
      trimestre: 4,
      total: 0,
      months: [
        { name: 'Oct', amount: '0.00' },
        { name: 'Nov', amount: '0.00' },
        { name: 'Dic', amount: '0.00' },
      ],
    },
  ];

  // ===== Cards =====
  readonly cards = [
    { id: 1, name: 'Card 1' },
    { id: 2, name: 'Card 2' },
    { id: 3, name: 'Card 3' },
  ];

  readonly Math = Math; // usado en template si se requiere

  constructor() {}

  ngOnInit(): void {}

  getTotalPages() {
    return this.cards;
  }
}
